/* Quick-view Gadea Loreak — selector de opciones desde las product cards.
   Abre con [data-iurop-quick-view] (data-product-url), lee {url}.js,
   pinta pills por opción, resuelve variante y añade por AJAX al side-cart. */
(function () {
  'use strict';
  if (window.__iuropQvInit) return;
  window.__iuropQvInit = true;

  var root, product, selected, money;

  function $(s, c) { return (c || root).querySelector(s); }

  function euro(cents) {
    var n = (Number(cents) || 0) / 100;
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function currentVariant() {
    if (!product) return null;
    return product.variants.find(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    }) || null;
  }

  function optionAvailable(optIndex, value) {
    return product.variants.some(function (v) {
      if (v.options[optIndex] !== value) return false;
      for (var i = 0; i < selected.length; i++) {
        if (i !== optIndex && v.options[i] !== selected[i]) return false;
      }
      return v.available;
    });
  }

  function renderOptions() {
    var wrap = $('[data-qv-options]');
    wrap.innerHTML = '';
    product.options.forEach(function (option, oi) {
      // /products/{handle}.js devuelve `options` como OBJETOS {name, position, values}
      // (no strings): interpolar el objeto pintaba "[object Object]" en el modal.
      // Se usa .name con fallback por si algún contexto sirviera strings.
      var name = (option && typeof option === 'object') ? (option.name || '') : option;
      var values = [];
      product.variants.forEach(function (v) {
        if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]);
      });
      var opt = document.createElement('div');
      opt.className = 'iurop-qv__opt';
      var label = document.createElement('p');
      label.className = 'iurop-qv__opt-name';
      label.textContent = name;
      var pills = document.createElement('div');
      pills.className = 'iurop-qv__pills';
      values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'iurop-qv__pill';
        b.textContent = val;
        if (selected[oi] === val) b.classList.add('is-active');
        if (!optionAvailable(oi, val)) b.classList.add('is-unavailable');
        b.addEventListener('click', function () {
          selected[oi] = val;
          renderOptions();
          sync();
        });
        pills.appendChild(b);
      });
      opt.appendChild(label);
      opt.appendChild(pills);
      wrap.appendChild(opt);
    });
  }

  function sync() {
    var v = currentVariant();
    var atc = $('[data-qv-atc]');
    var un = $('[data-qv-unavailable]');
    if (v) {
      $('[data-qv-price]').textContent = euro(v.price);
      var cmp = $('[data-qv-compare]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        cmp.textContent = euro(v.compare_at_price);
        cmp.hidden = false;
      } else { cmp.hidden = true; }
      if (v.featured_image && v.featured_image.src) $('[data-qv-image]').src = v.featured_image.src;
      atc.disabled = !v.available;
      /* Etiquetas desde Ajustes del tema (el snippet las emite en data-txt-*). */
      atc.textContent = v.available
        ? ((root && root.dataset && root.dataset.txtAtc) || 'Añadir al carrito')
        : ((root && root.dataset && root.dataset.txtAgotado) || 'Agotado');
      un.hidden = true;
    } else {
      atc.disabled = true;
      un.hidden = false;
    }
  }

  function open(url) {
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        selected = first.options.slice();
        $('[data-qv-title]').textContent = p.title;
        $('[data-qv-link]').href = p.url;
        var img = $('[data-qv-image]');
        img.src = (first.featured_image && first.featured_image.src) || (p.images && p.images[0]) || '';
        img.alt = p.title;
        $('[data-qv-qty]').value = 1;
        renderOptions();
        sync();
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('iurop-qv-locked');
        var closeBtn = $('.iurop-qv__close');
        if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
      })
      .catch(function () { window.location.href = url; });
  }

  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('iurop-qv-locked');
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available) return;
    var qty = Math.max(1, parseInt($('[data-qv-qty]').value, 10) || 1);
    var atc = $('[data-qv-atc]');
    atc.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: v.id, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (rr) { return rr.json(); });
      })
      .then(function (cart) {
        atc.classList.remove('is-loading');
        close();
        if (window.iuropCartDrawer && typeof window.iuropCartDrawer.open === 'function') {
          window.iuropCartDrawer.open(cart);
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: { cart: cart } }));
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'iurop-quick-view' } }));
      })
      .catch(function () { atc.classList.remove('is-loading'); });
  }

  function init() {
    root = document.getElementById('IuropQuickView');
    if (!root) return;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-iurop-quick-view]');
      if (t) {
        e.preventDefault();
        open(t.getAttribute('data-product-url'));
        return;
      }
      if (e.target.closest('[data-qv-close]')) { close(); return; }
      if (e.target.closest('[data-qv-minus]')) {
        var i1 = $('[data-qv-qty]'); i1.value = Math.max(1, (parseInt(i1.value, 10) || 1) - 1); return;
      }
      if (e.target.closest('[data-qv-plus]')) {
        var i2 = $('[data-qv-qty]'); i2.value = (parseInt(i2.value, 10) || 1) + 1; return;
      }
      if (e.target.closest('[data-qv-atc]')) { addToCart(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
